import React from "react";
import { ExplainerSection, NAVY, CYAN, LIME, INK, LIGHT, AMBER } from "./ExplainerSection";

const CoverageIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="WLAN-Ausleuchtung im gesamten Gebäude">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Floor plan */}
    <rect x="50" y="40" width="300" height="170" fill="#fff" stroke={NAVY} strokeWidth="2.5" />
    <line x1="170" y1="40" x2="170" y2="130" stroke={NAVY} strokeWidth="2" />
    <line x1="170" y1="130" x2="50" y2="130" stroke={NAVY} strokeWidth="2" />
    <line x1="260" y1="110" x2="260" y2="210" stroke={NAVY} strokeWidth="2" />
    <line x1="260" y1="110" x2="350" y2="110" stroke={NAVY} strokeWidth="2" />
    <text x="105" y="90" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill={INK} opacity="0.6">BÜRO</text>
    <text x="305" y="80" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill={INK} opacity="0.6">MEETING</text>
    <text x="105" y="180" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill={INK} opacity="0.6">LAGER</text>
    {/* AP with expanding rings */}
    <circle cx="215" cy="150" r="10" fill={NAVY} />
    <path d="M 208 146 q 7 -7 14 0" fill="none" stroke="#fff" strokeWidth="1.8" />
    <path d="M 211 150 q 4 -4 8 0" fill="none" stroke="#fff" strokeWidth="1.8" />
    {[0, 1, 2].map((i) => (
      <circle key={i} cx="215" cy="150" r="20" fill="none" stroke={CYAN} strokeWidth="2">
        <animate attributeName="r" values="15;120" dur="3s" begin={`${i}s`} repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.9;0" dur="3s" begin={`${i}s`} repeatCount="indefinite" />
      </circle>
    ))}
    {/* Devices with signal */}
    {[{ x: 90, y: 70 }, { x: 310, y: 60 }, { x: 90, y: 190 }, { x: 320, y: 180 }].map((d, i) => (
      <g key={i}>
        <rect x={d.x - 6} y={d.y - 9} width="12" height="18" rx="2" fill={NAVY} />
        <circle cx={d.x} cy={d.y - 16} r="3" fill={LIME}>
          <animate attributeName="opacity" values="0.3;1;0.3" dur="1.6s" begin={`${i * 0.3}s`} repeatCount="indefinite" />
        </circle>
      </g>
    ))}
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      VOLLE AUSLEUCHTUNG · KEIN FUNKLOCH
    </text>
  </svg>
);

const VlanIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="VLAN-Trennung: Mitarbeiter, Gäste und Geräte getrennt">
    <rect width="400" height="260" fill={LIGHT} />
    {/* AP at top */}
    <circle cx="200" cy="45" r="14" fill={NAVY} />
    <path d="M 190 40 q 10 -10 20 0" fill="none" stroke="#fff" strokeWidth="2" />
    <text x="200" y="22" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill={INK}>1 ACCESS POINT</text>
    {/* Three separated lanes */}
    {[{ x: 70, c: NAVY, label: "MITARBEITER" }, { x: 170, c: CYAN, label: "GÄSTE" }, { x: 270, c: AMBER, label: "IOT / GERÄTE" }].map((l, i) => (
      <g key={i}>
        <path d={`M 200 60 L ${l.x + 30} 100`} stroke={l.c} strokeWidth="2.5" fill="none" />
        <rect x={l.x} y="100" width="60" height="95" rx="4" fill="#fff" stroke={l.c} strokeWidth="2.5" />
        <text x={l.x + 30} y="215" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="7" fill={INK}>{l.label}</text>
        {/* moving packet */}
        <circle r="4" fill={l.c}>
          <animate attributeName="cy" values="115;180;115" dur="2.4s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
          <animate attributeName="cx" values={`${l.x + 30};${l.x + 30}`} dur="2.4s" repeatCount="indefinite" />
        </circle>
      </g>
    ))}
    {/* Divider walls */}
    <line x1="145" y1="95" x2="145" y2="200" stroke={INK} strokeWidth="3" strokeDasharray="6 4" />
    <line x1="245" y1="95" x2="245" y2="200" stroke={INK} strokeWidth="3" strokeDasharray="6 4" />
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      VLAN-TRENNUNG · SAUBER GETRENNTE NETZE
    </text>
  </svg>
);

const GuestIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Gast-WLAN mit eigenem Login-Portal">
    <rect width="400" height="260" fill={INK} />
    {/* Phone */}
    <rect x="150" y="30" width="100" height="180" rx="14" fill="#fff" stroke={CYAN} strokeWidth="2" />
    <rect x="162" y="48" width="76" height="130" rx="4" fill={LIGHT} />
    {/* Wifi icon */}
    <path d="M 182 85 q 18 -16 36 0" fill="none" stroke={NAVY} strokeWidth="3" strokeLinecap="round" />
    <path d="M 189 95 q 11 -10 22 0" fill="none" stroke={NAVY} strokeWidth="3" strokeLinecap="round" />
    <circle cx="200" cy="104" r="3.5" fill={LIME} />
    <text x="200" y="125" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fontWeight="bold" fill={INK}>GAST-WLAN</text>
    {/* Login button */}
    <rect x="172" y="140" width="56" height="18" rx="3" fill={LIME}>
      <animate attributeName="opacity" values="1;0.6;1" dur="1.8s" repeatCount="indefinite" />
    </rect>
    <text x="200" y="152" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fontWeight="bold" fill={INK}>VERBINDEN</text>
    <circle cx="200" cy="196" r="6" fill="none" stroke="#ccc" strokeWidth="2" />
    {/* Check appears */}
    <g>
      <animate attributeName="opacity" values="0;0;1;1" dur="3s" repeatCount="indefinite" />
      <circle cx="290" cy="80" r="22" fill={LIME} />
      <path d="M 280 80 l 7 7 l 13 -15" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" />
    </g>
    <text x="290" y="122" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill="#fff" opacity="0.8">SICHER GETRENNT</text>
    <text x="290" y="135" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill="#fff" opacity="0.8">VOM FIRMENNETZ</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      GAST-PORTAL · PROFESSIONELLER EINDRUCK
    </text>
  </svg>
);

const DashIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Zentrales WLAN-Dashboard mit Live-Status">
    <rect width="400" height="260" fill={LIGHT} />
    <rect x="40" y="30" width="320" height="180" rx="8" fill="#fff" stroke={NAVY} strokeWidth="2" />
    <rect x="40" y="30" width="320" height="24" rx="8" fill={NAVY} />
    <text x="55" y="46" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="1">WLAN-CONTROLLER · LIVE</text>
    {/* AP rows */}
    {[{ n: "AP-EMPFANG", u: "14" }, { n: "AP-BÜRO-1", u: "22" }, { n: "AP-LAGER", u: "6" }, { n: "AP-MEETING", u: "9" }].map((r, i) => (
      <g key={i}>
        <rect x="56" y={68 + i * 33} width="288" height="26" rx="3" fill={LIGHT} />
        <circle cx="72" cy={81 + i * 33} r="5" fill={LIME}>
          <animate attributeName="opacity" values="1;0.35;1" dur="1.6s" begin={`${i * 0.35}s`} repeatCount="indefinite" />
        </circle>
        <text x="88" y={85 + i * 33} fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>{r.n}</text>
        {/* signal bars */}
        {[0, 1, 2].map((b) => (
          <rect key={b} x={250 + b * 8} y={87 + i * 33 - (b + 1) * 4} width="5" height={(b + 1) * 4} fill={CYAN} />
        ))}
        <text x="300" y={85 + i * 33} fontFamily="ui-monospace, monospace" fontSize="9" fill={NAVY} fontWeight="bold">{r.u} NUTZER</text>
      </g>
    ))}
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      ALLES IM BLICK · WIR SEHEN PROBLEME ZUERST
    </text>
  </svg>
);

const ITEMS = [
  { step: "01", illu: CoverageIllu, title: "Kein Funkloch, nirgends", desc: "Wir messen Ihr Gebäude aus und platzieren Access Points so, dass jeder Winkel versorgt ist – vom Empfang bis zum Lager. Das Ergebnis: stabiles WLAN an jedem Arbeitsplatz.", testId: "coverage" },
  { step: "02", illu: VlanIllu, title: "Getrennte Netze, eine Hardware", desc: "Mitarbeiter, Gäste und IoT-Geräte funken über denselben Access Point – aber in sauber getrennten VLANs. Ein infiziertes Gerät im Gastnetz kommt nie an Ihre Firmendaten.", testId: "vlan" },
  { step: "03", illu: GuestIllu, title: "Gäste-WLAN mit Stil", desc: "Ihre Besucher verbinden sich über ein eigenes Login-Portal mit Ihrem Logo – sicher getrennt vom Firmennetz. Professioneller Eindruck inklusive, Passwort-Zettel adé.", testId: "guest" },
  { step: "04", illu: DashIllu, title: "Wir sehen Probleme vor Ihnen", desc: "Alle Access Points melden sich an unseren zentralen Controller. Fällt ein Gerät aus oder wird die Auslastung kritisch, wissen wir es sofort – oft bevor Sie es überhaupt merken.", testId: "dashboard" },
];

export const WlanExplainers = () => (
  <ExplainerSection
    eyebrow="So funktioniert Managed WLAN"
    titleA="Vier Bausteine."
    titleB="Einfach erklärt."
    intro="Gutes Firmen-WLAN ist mehr als ein Router im Regal. Hier sehen Sie visuell, was professionelles Managed WLAN ausmacht – und warum es sich lohnt."
    items={ITEMS}
    testId="wlan-explainers"
  />
);
